import { render, staticRenderFns } from "./SearchCategoriesMobile.vue?vue&type=template&id=54e86ec0&"
import script from "./SearchCategoriesMobile.vue?vue&type=script&lang=ts&"
export * from "./SearchCategoriesMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports